import { Component } from '@angular/core';

@Component({
  selector: 'login-layout',
  templateUrl: './login-layout.component.html'
})
export class  LoginLayoutComponent {
  
}
